import type { CountdownRenderProps } from 'react-countdown';
import Countdown from 'react-countdown';

type PredictionCardCountDownProps = {
  value: number;
};

export const PredictionCountDown = ({ value }: PredictionCardCountDownProps) => {
  return (
    <Countdown
      date={value}
      renderer={({ formatted: { minutes, seconds } }: CountdownRenderProps) => {
        return (
          <span
            style={{
              fontFeatureSettings: "'tnum' on, 'lnum' on",
            }}
            className="font-tnum font-lnum"
          >{`${minutes}:${seconds}`}</span>
        );
      }}
    />
  );
};
